<template>
  <b-container>
    <b-row>
      <b-col class="col-3 font-weight-bold">Data:</b-col>
      <b-col>
        {{ plantao.dia > 9 ? plantao.dia : "0" + plantao.dia }}/{{
          new Date(plantao.mes).getUTCMonth() + 1 > 9
            ? new Date(plantao.mes).getUTCMonth() + 1
            : "0" + (new Date(plantao.mes).getUTCMonth() + 1)
        }}/{{ new Date(plantao.mes).getUTCFullYear() }}
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-3 font-weight-bold">Plantão:</b-col>
      <b-col>{{ plantao.plantao }}</b-col>
    </b-row>
    <b-row>
      <b-col class="col-3 font-weight-bold">Profissional substituto:</b-col>
      <b-col>
        <auto-complete
          v-model="profissionalSelecionado"
          :suggestions="profissionaisFiltrados"
          @complete="procuraProfissionais($event)"
          :minLength="3"
          field="nome"
          id="input-profissional"
          @item-select="selecionaProfissional"
        >
          <template #item="pessoa">
            <b-container fluid class="d-flex justify-content-between">
              <div>{{ pessoa.item.nome }}</div>
              <div>{{ pessoa.item.cpf }}</div>
            </b-container>
          </template>
        </auto-complete>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-3 font-weight-bold">CPF:</b-col>
      <b-col>{{
        profissionalSelecionado
          ? profissionalSelecionado.cpf
          : null | converteCPF
      }}</b-col>
    </b-row>
  </b-container>
</template>

<script>
import AutoComplete from "primevue/autocomplete";

export default {
  filters: {
    converteCPF: function (value) {
      if (!value) return "";
      if (value.length == 10) {
        value = "0" + value;
      } else if (value.length == 9) {
        value = "00" + value;
      }
      return (
        value.substring(0, 3) +
        "." +
        value.substring(3, 6) +
        "." +
        value.substring(6, 9) +
        "-" +
        value.substring(9)
      );
    },
  },
  components: {
    AutoComplete,
  },
  props: ["plantao"],
  data() {
    return {
      profissionalSelecionado: null,
      profissionaisFiltrados: [],
    };
  },
  methods: {
    procuraProfissionais(event) {
      this.$http
        .get("/pessoaspornomeestudantes/" + event.query.toLowerCase())
        .then((result) => {
          console.log("profissionais", result.data);
          this.profissionaisFiltrados = result.data;
          //console.log(result.data);
        });
    },
    selecionaProfissional() {
      this.$emit("selecionaProfissional", this.profissionalSelecionado);
    },
  },
};
</script>

<style></style>
